import { format, parseISO, isValid, differenceInDays, addMonths } from 'date-fns';
import { adminStore } from '../stores/adminStore';

const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';

export const DATE_FORMAT_PRESETS: Array<{ value: string; label: string; example: string }> = [
  { value: 'dd/MM/yyyy', label: 'UK — dd/MM/yyyy', example: '29/04/2026' },
  { value: 'MM/dd/yyyy', label: 'US — MM/dd/yyyy', example: '04/29/2026' },
  { value: 'yyyy-MM-dd', label: 'ISO — yyyy-MM-dd', example: '2026-04-29' },
  { value: 'd MMM yyyy', label: 'Short month — d MMM yyyy', example: '29 Apr 2026' },
  { value: 'd MMMM yyyy', label: 'Long month — d MMMM yyyy', example: '29 April 2026' },
];

function getConfiguredDateFormat(): string {
  const fmt = adminStore.dateFormat;
  return typeof fmt === 'string' && fmt.length > 0 ? fmt : DEFAULT_DATE_FORMAT;
}

function getConfiguredDateTimeFormat(): string {
  return `${getConfiguredDateFormat()} HH:mm`;
}

export function formatDate(date: string | Date | undefined): string {
  if (!date) return '-';
  const d = typeof date === 'string' ? parseISO(date) : date;
  return isValid(d) ? format(d, getConfiguredDateFormat()) : '-';
}

export function formatDateTime(date: string | Date | undefined): string {
  if (!date) return '-';
  const d = typeof date === 'string' ? parseISO(date) : date;
  return isValid(d) ? format(d, getConfiguredDateTimeFormat()) : '-';
}

export function formatToday(): string {
  return format(new Date(), getConfiguredDateFormat());
}

export function calculateExpiry(date: string, periodicityMonths: string): Date | null {
  if (!date || !periodicityMonths) return null;
  const baseDate = parseISO(date);
  const months = parseInt(periodicityMonths);
  if (!isValid(baseDate) || isNaN(months)) return null;
  return addMonths(baseDate, months);
}

export function getDaysUntil(date: Date): number {
  return differenceInDays(date, new Date());
}

export function getRAGStatus(date: Date): 'red' | 'amber' | 'green' {
  const daysUntil = getDaysUntil(date);
  if (daysUntil < 0) return 'red';
  if (daysUntil <= 30) return 'amber';
  return 'green';
}
